import React from 'react';
import { Grid, Icon, TransitionablePortal } from 'semantic-ui-react';
import { useResponsive } from 'ahooks';

import { useNotification } from 'src/hooks';

const Notification: React.FC = () => {
  const [{ isOpen, color, icon, message, isOff }, notify] = useNotification();
  const screen = useResponsive();

  if (isOff) {
    return null;
  }

  return (
    <TransitionablePortal
      open={isOpen}
      transition={{ animation: 'fly left', duration: 500 }}
      closeOnDocumentClick={false}
    >
      <div
        // inverted={type !== 'info'}
        style={{
          right: 10,
          position: 'fixed',
          top: 10,
          zIndex: 1000,
          width: !screen.sm ? '95%' : '400px',
          overflowWrap: 'break-word',
        }}
        className="dropdown-shadow p-24 border-radius-6 bg-white"
      >
        <Grid columns={3} className="h-100">
          <Grid.Column width={2} verticalAlign="middle">
            <Icon color={color} name={icon} size="big" />
          </Grid.Column>
          <Grid.Column width={12}>
            <p className="fs-16">{message}</p>
          </Grid.Column>
          <Grid.Column width={2}>
            <Icon name="close" onClick={notify.off} />
          </Grid.Column>
        </Grid>
      </div>
    </TransitionablePortal>
  );
};

export default Notification;
